import * as React from 'react'

export const Form = ({ input }) => {
  const { props } = input
  return (
    <div>
      <h2 className="pt-heading">{props.label}</h2>
    </div>
  )
}

export const Configuration = () => {
  return <div />
}
